import React from "react";
import { Link } from "react-router-dom";
import { FlaskConical, Settings as SettingsIcon } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { translateFr as tfr } from "@/i18n";

/**
 * DemoBanner — global subtle banner shown when user.demo_mode is true.
 * Sits below the navbar and provides a quick path to Settings to disable.
 */
export default function DemoBanner() {
  const { user } = useAuth();
  if (!user?.demo_mode) return null;

  return (
    <div
      className="w-full border-b border-info/25 bg-info/[0.07] backdrop-blur-sm"
      data-testid="demo-banner"
      role="status"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-2 flex items-center justify-between gap-3 text-info">
        <div className="flex items-center gap-2 min-w-0">
          <FlaskConical className="h-3.5 w-3.5 shrink-0" />
          <span className="text-[11px] md:text-xs font-medium tracking-wide uppercase truncate">
            {tfr("Mode démo actif")}
          </span>
          <span className="hidden md:inline text-[11px] text-info/70 truncate">
            {tfr("· Vos vraies données sont préservées et coexistent avec les données de démonstration")}
          </span>
        </div>
        <Link
          to="/settings"
          className="shrink-0 inline-flex items-center gap-1 text-[11px] md:text-xs hover:underline"
          data-testid="demo-banner-settings-link"
        >
          <SettingsIcon className="h-3 w-3" />
          {tfr("Gérer")}
        </Link>
      </div>
    </div>
  );
}
